import { toObject } from "../../core/utils";

class BustypePageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return toObject(data);
  }
}

export default BustypePageTransform;



// WEBPACK FOOTER //
// ./src/pages/bustype/bustype.transforms.js